import { ConversionUtil } from "@mcleod/core";
import { LMEGeneralSettings } from "@mcleod/general";
import { AutogenModelAgentAccessCtrl, AutogenRowAgentAccessCtrl, RowAgentAccessCtrlFields } from "./autogen/AutogenModelAgentAccessCtrl";

export class ModelAgentAccessCtrl extends AutogenModelAgentAccessCtrl<RowAgentAccess> {
    constructor() {
        super(RowAgentAccess);
    }
}

export function getAgentAccessBoolean(field: keyof RowAgentAccessCtrlFields, valueIfNull: boolean = false): boolean {
    const result = getAgentAccessValue(field);
    if (typeof result === "string")
        return ConversionUtil.parseBoolean(result);
    return result ?? valueIfNull;
}

export function getAgentAccessValue(field: keyof RowAgentAccessCtrlFields): any {
    return LMEGeneralSettings.getSingleton().getAgentAccessControl()[field];
}

export class RowAgentAccess extends AutogenRowAgentAccessCtrl {
}
